import { useAddons, usePrice } from 'hooks'
import React from 'react'
import { Stepper, Step, StepLink } from './Breadcrumb.styles'
import useOptimizelyExperiment from 'hooks/experiments/useOptimizelyExperiment'
import { WithOptimizelyProps, withOptimizely } from '@optimizely/react-sdk'
import { Link, useLocation } from 'react-router-dom'

const DRIVER_DETAILS_PATH = '/quote/driver-details'
const DRIVING_LICENCE_PATH = '/quote/driving-licence'
const LEGAL_DECLARATION_PATH = '/quote/legal-declaration'
const ADD_ONS_PATH = '/quote/addons'
const PAYMENT_PATH = '/quote/payment'

const BreadCrumb: React.FC<WithOptimizelyProps> = ({ optimizely }) => {
  const shouldUseSplitAddonsPage = useOptimizelyExperiment(
    optimizely,
    'addons_page',
    'page_enabled',
  )
  const { price } = usePrice()
  const { availableAddons } = useAddons()

  const location = useLocation()

  let includeAddonsInSteps = false
  if (shouldUseSplitAddonsPage) {
    includeAddonsInSteps = true
    if (price.TotalPrice && (!availableAddons || !availableAddons.length)) {
      includeAddonsInSteps = false
    }
  }

  const steps = [
    {
      href: DRIVER_DETAILS_PATH,
    },
    {
      href: DRIVING_LICENCE_PATH,
      altHrefs: ['/quote/driver-details/more-info'],
    },
    {
      href: LEGAL_DECLARATION_PATH,
    },
    ...(includeAddonsInSteps
      ? [
          {
            href: ADD_ONS_PATH,
          },
        ]
      : []),
    {
      href: PAYMENT_PATH,
    },
  ]

  let activeIndex = steps.findIndex(
    (item) =>
      window.location.pathname === item.href ||
      item.altHrefs?.includes(window.location.pathname),
  )

  return (
    <Stepper current={activeIndex} count={steps.length}>
      {steps.map((item, index) => {
        const isActive = index === activeIndex
        const isComplete = index < activeIndex

        return (
          <Step
            className={
              isActive ? 'active' : isComplete ? 'complete' : 'not-started'
            }
            key={index}
          >
            {isComplete ? (
              <StepLink
                as={Link}
                to={{ pathname: item.href, search: location.search }}
              />
            ) : (
              <StepLink as='span' />
            )}
          </Step>
        )
      })}
    </Stepper>
  )
}

export default withOptimizely(BreadCrumb)
